import { apiClient } from './client';
import type { EntrySeverity } from './deficiency-entries';

export interface AiSuggestion {
  id: string;
  title: string;
  description: string | null;
  severity: EntrySeverity;
  /**
   * `user_curated` is set when the inspector saved an accepted/edited AI
   * vision finding back to their library (issue #44). These rank above
   * `ai_generated` defaults in the strip.
   */
  source: 'ai_generated' | 'user_library' | 'user_curated';
}

interface GetSuggestionsParams {
  sectionName: string;
  componentName: string;
  propertyType?: string;
  existingFindings?: string[];
}

export const suggestionsApi = {
  get: async (params: GetSuggestionsParams): Promise<AiSuggestion[]> => {
    const res = await apiClient.post<{ success: true; data: { suggestions: AiSuggestion[] } }>(
      '/suggestions',
      params,
    );
    if (!res.success) throw new Error((res as unknown as { error: string }).error);
    return res.data.suggestions;
  },
};
